import { roundTo2Decimals } from '@oskecare/fe-utilities/scripts/helpers';

/**
 * TODO: remove smurf naming from getters after we are committed to wso2 billing
 *
 * @property {BillingDocument[]} _currentPeriodPaidDocuments
 * @property {BillingDocument[]} _unpaidBillingDocuments
 * @property {BillingPeriod} latestBillingPeriod
 * */
export default class BillingSummary {
  /**
   * @param {BillingDocument[]} currentPeriodPaidDocuments
   * @param {BillingDocument[]} unpaidBillingDocuments
   * @param {BillingPeriod} latestBillingPeriod
   */
  constructor({ currentPeriodPaidDocuments, unpaidBillingDocuments, latestBillingPeriod }) {
    this._currentPeriodPaidDocuments = currentPeriodPaidDocuments;
    this._unpaidBillingDocuments = unpaidBillingDocuments;
    this.summaryPeriod = latestBillingPeriod;
  }

  /**
   * @returns {BillingDocument[]} all documents displayed in summary, i.e. documents from current period along unpaid documents from previous periods
   */
  get _allSummaryBillingDocuments() {
    return [...this._currentPeriodPaidDocuments, ...this._unpaidBillingDocuments];
  }

  /**
   * @returns {number}
   */
  get summaryAmountUnpaid() {
    return roundTo2Decimals(
      this._allSummaryBillingDocuments.reduce((sum, item) => sum + item.amountRemaining, 0),
    );
  }

  /**
   * @returns {number}
   */
  get summaryAmountTotal() {
    return roundTo2Decimals(
      this._allSummaryBillingDocuments.reduce((sum, item) => sum + item.amountDue, 0),
    );
  }

  /**
   * @returns {string} due date of the oldest unpaid document or due date of the latest document in case all of the documents are paid
   */
  get summaryDueDate() {
    return this._unpaidBillingDocuments.length
      ? this._unpaidBillingDocuments.map(document => document.dueDate).sort((a, b) => b - a)[0]
      : this._allSummaryBillingDocuments[0].dueDate;
  }

  /**
   * TODO: merge with `_allSummaryBillingDocuments` after we are committed to wso2 billing
   *
   * @returns {BillingDocument[]} all documents displayed in summary, i.e. documents from current period along unpaid documents from previous periods
   */
  get items() {
    return this._allSummaryBillingDocuments;
  }
}
